<div class="row m-0">
  <label class="col-md-1 col-6">
    To:
  </label>
  <div class="col-md-11 col-6">
    <b>{{toEmailAddress}}</b>
  </div>
</div>
<div class="row m-0">
  <label class="col-md-1 col-6">
    From:
  </label>
  <div class="col-md-11 col-6">
    <b>{{fromEmailAddress}}</b>
  </div>
</div>
<div class="row m-0">
  <label class="col-md-1 col-6">
    Reply-To:
  </label>
  <div class="col-md-11 col-6">
    <b>{{replyToEmailAddress}}</b>
  </div>
</div>
<div class="row m-0">
  <label class="col-md-1 col-6">
    Subject
  </label>
  <div class="col-md-11 col-6">
    <input type="text" value="Subject..." [(ngModel)]="emailSubject" />
  </div>
</div>
<div class="row ml-0 mr-0 mt-2">
  <div class="col-md-1 col-6">
    <label>
      Message
    </label>
    
  </div>
  <div class="col-md-11 col-6">
    <textarea id="clientEmailTemplate" contenteditable="true" [(ngModel)]="emailMessage" class="form-control h-100" rows="10"></textarea>
  </div>
</div>
<div class="row ml-0 mr-0 mt-2" *ngIf="!confirmEmail">
  <div class="offset-md-1 offset-6 col-md-11 col-6">
    <input class="btn btn-secondary btn-sm" type="button" value="Copy To Clipboard" (click)="copyText()" />
  </div>
</div>
<div class="row ml-0 mr-0 mt-2" *ngIf="!confirmEmail">
  <div class="offset-md-1 offset-6 col-md-11 col-6">
    <input class="btn btn-secondary btn" type="button" value="Send Test Email" (click)="sendTestEmail()" />
    <span class="alert alert-info">
      A test email will be sent to your email account at <b>{{testEmailAddress}}</b>
    </span>
  </div>
</div>

<div class="row m-0" *ngIf="!confirmEmail">
  <div class="col text-right">
    <input class="btn btn-primary" type="button" value="Send Email" (click)="sendEmail()" [disabled]="!client.email" />
  </div>
</div>
<div class="row ml-0 mr-0 mt-2 text-center" *ngIf="confirmEmail">
  <div class="col-12">
    <p >
      <i>I confirm that I have reviewed the email message and taken appropriate safeguards to limit the amount and type of information I am disclosing
      through unencrypted e-email.  I confirm that I have verified the email address of my patient that it is correct and valid and that my patient
      has agreed to receive this communication via unencrypted e-mail.</i>
    </p >
  </div>
  <div class="col-12 justify-content-center">
    <input type="button" value="Cancel" class="btn btn-secondary" (click)="confirmEmail = false" />
    <input type="button" value="Confirm and Send Email" class="btn btn-primary" (click)="confirmEmailSend()" />
  </div>
</div>
<div class="row m-0" *ngIf="!client.email">
  <p class="col alert alert-danger">
    You must assign an email address to this client in order to send an email.
  </p>
</div>
<div class="row m-0">
  <div class="alert alert-warning">
    <p>Note that the HIPAA Privacy Rule does not prohibit the use of unecrypted e-mail for treatment-related communications 
    between health care providers and patients.  However, <b>other safeguards should be applied to reasonably protect privacy, 
    such as limiting the amount or type of information disclosed through the unencrypted e-mail.</b></p>
    <p>
    You can read more here about this from HHS <i><a href="https://www.hhs.gov/hipaa/for-professionals/faq/570/does-hipaa-permit-health-care-providers-to-use-email-to-discuss-health-issues-with-patients/index.html">Does the HIPAA Privacy Rule permit health care providers to use e-mail to discuss health issues and treatment with their patients?</a></i> 
    </p>
  </div>
</div>


// WEBPACK FOOTER //
// ./src/app/client-send-invitation/client-send-invitation.component.html